import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import Apiservice from "../Apiservice";
import { formatDate } from "../Utils/Utils";

const IncidentReport = () => {

    const navigate = useNavigate();
    const [incidentReport, setIncidentReport] = useState([]);

    // 🔹 Inline Styles
    const unreadRowStyle = {
        borderLeft: "5px solid #0d6efd",
        fontWeight: 500
    };

    const unreadCellStyle = {
        background: "#eef4ff"
    };


    const unreadDotStyle = {
        height: "8px",
        width: "8px",
        backgroundColor: "#0d6efd",
        borderRadius: "50%",
        display: "inline-block",
        marginRight: "6px"
    };

    useEffect(() => {
        fetchData();
    }, []);

    const fetchData = async () => {
        let userId = localStorage.getItem("user_id");
        let roleId = localStorage.getItem("role_id");
        let nricOrFin = localStorage.getItem('nricOrFin');
        let presentUserType = localStorage.getItem('userType');

        let data = {};
        if (presentUserType === 'normal') {
            data = roleId == 1
                ? { status: 0 }
                : { userId, status: 0 };
        }
        else{
            data = {
                nricOrFin, status:0
            }
        }



        const result = await Apiservice.IncidentReportGet(data);
        console.log("data", data);
        console.log("report", result)

        if (result.success === true) {
            setIncidentReport(result.data);
        }
    };

    const handleAdd = () => {
        navigate("/incidentreportadd");
    };

    const handleView = async (id) => {
        let data = {
            incidentReportId: id,
            isView: 1,
            status: 0
        };

        let result = await Apiservice.IncidentReportUpdate(data);

        if (result.success !== true) {
            alert(result.message);
            return;
        }

        // 🔔 Notify other components
        window.dispatchEvent(new Event("incidentViewed"));

        navigate("/incidentreportview", { state: { id } });
    };


    return (
        <div className="container-fluid py-4">
            <div className="card shadow-lg border-0 rounded-3">

                {/* Header */}
                <div className="card-header d-flex justify-content-between align-items-center bg-primary text-white">
                    <h5 className="mb-0">Incident Reports</h5>
                    <button className="btn btn-light btn-sm" onClick={handleAdd}>
                        + Add Report
                    </button>
                </div>

                {/* Body */}
                <div className="card-body p-3">
                    <div className="table-responsive">
                        <table className="table table-hover table-bordered align-middle">
                            <thead className="table-primary text-center">
                                <tr>
                                    <th style={{ width: "5%" }}>#</th>
                                    <th style={{ width: "20%" }}>Site</th>
                                    <th style={{ width: "15%" }}>Place</th>
                                    <th style={{ width: "20%" }}>Location</th>
                                    <th style={{ width: "15%" }}>Date</th>
                                    <th style={{ width: "10%" }}>Time</th>
                                    <th style={{ width: "15%" }}>Actions</th>
                                </tr>
                            </thead>

                            <tbody>
                                {incidentReport.length > 0 ? (
                                    incidentReport.map((incident, index) => (
                                        <tr
                                            key={index}
                                            style={incident.isView === 0 ? unreadRowStyle : {}}
                                        >
                                            <td style={incident.isView === 0 ? unreadCellStyle : {}}>
                                                {index + 1}
                                            </td>

                                            <td style={incident.isView === 0 ? unreadCellStyle : {}}>
                                                {incident.siteDetails[0]?.name}
                                            </td>

                                            <td style={incident.isView === 0 ? unreadCellStyle : {}}>
                                                {incident.place}
                                            </td>

                                            <td style={incident.isView === 0 ? unreadCellStyle : {}}>
                                                {incident.location}
                                            </td>

                                            <td style={incident.isView === 0 ? unreadCellStyle : {}}>
                                                {formatDate(incident.date)}
                                            </td>

                                            <td style={incident.isView === 0 ? unreadCellStyle : {}}>
                                                {incident.time}
                                            </td>

                                            <td style={incident.isView === 0 ? unreadCellStyle : {}}>
                                                <button
                                                    className="btn btn-outline-primary btn-sm"
                                                    onClick={() => handleView(incident.id)}
                                                >
                                                    View
                                                </button>
                                            </td>
                                        </tr>

                                    ))
                                ) : (
                                    <tr>
                                        <td colSpan={7} className="text-center text-muted py-3">
                                            No incident report found
                                        </td>
                                    </tr>
                                )}
                            </tbody>

                        </table>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default IncidentReport;
